import { z } from 'zod';
import { AuditSchema } from '../settings/audit-schema';

export const EnrollmentSchema = z.object({
  businessId: z.string(),
  clientId: z.string(), // CRM Reference (owners/{id}/clients)
  studentUid: z.string().nullable().optional(), // Firebase Auth UID (null if pending activation)
  courseId: z.string(),
  saleId: z.string().nullable().optional(),
  source: z.enum(['sale', 'manual', 'import', 'admin_grant']).default('manual'),
  
  status: z.enum(['pending', 'active', 'revoked', 'expired']).default('pending'),
  
  // Datos del Estudiante (Capturados en activación)
  studentProfile: z.object({
    name: z.string().min(2, 'El nombre es obligatorio'),
    phone: z.string().min(7, 'El teléfono es obligatorio'),
    birthdate: z.string().optional(),
    email: z.string().email().optional(),
  }).optional(),
  
  // Progress tracking
  completedLessons: z.array(z.string()).default([]), // Array of IDs
  lastAccessedAt: z.any().nullable().optional(),
  
  // activation link logic
  activationToken: z.string().nullable().optional(),
  
  audit: AuditSchema.optional(),
});

export type Enrollment = z.infer<typeof EnrollmentSchema>;
export type EnrollmentWithId = Enrollment & { id: string };
